/**
* Hover Columns JS
* -----------------------------------------------------------------------------
*
* All the JS for the Hover Columns component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {

    className: 'hover-columns',
    selector: function() {
      return '.' + this.className;
    },
    init: function() {
      // Only run this on desktop (Tailwind 'lg': min-width 1024px)
      if ( window.matchMedia( '(min-width: 1024px)' ).matches ) {
        const hoverColumns = document.querySelectorAll( '[data-component="hover-columns"] .group' );

        hoverColumns.forEach( ( column ) => {
          const title = column.querySelector( 'p.hover-columns__title' );
          const description = column.querySelector( 'p.hover-columns__desc' );

          if ( !title || !description ) return;

          const applyTransform = () => {
            const descHeight = description.offsetHeight + 12;
            title.style.transform = `translateY(-${descHeight}px)`;
          };

          const resetTransform = () => {
            title.style.transform = `translateY(0)`;
          };

          column.addEventListener( 'mouseenter', applyTransform );
          column.addEventListener( 'mouseleave', resetTransform );

          column.addEventListener( 'focusin', applyTransform );
          column.addEventListener( 'focusout', resetTransform );

          column.addEventListener( 'mousedown', applyTransform );
          column.addEventListener( 'mouseup', resetTransform );
        } );
      }
    },
    finalize: function() {},
  };

  app.registerComponent( 'hover-columns', COMPONENT );
} )( app );
